import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();

  const items = [
    { key: 'updated', icon: 'ri-refresh-line' },
    { key: 'verified', icon: 'ri-shield-check-line' },
    { key: 'free', icon: 'ri-gift-line' },
    { key: 'guides', icon: 'ri-book-open-line' },
  ];

  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {items.map((item) => (
            <div key={item.key} className="flex items-center gap-3 justify-center">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full flex-shrink-0">
                <i className={`${item.icon} text-base`}></i>
              </span>
              <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">
                {t(`trust.${item.key}`)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}